const addStyle = (styleList, key, value) => {
  if (value) {
    styleList[key] = value;
  }
};

const getTrackingAttributes = (fields) => {
  const trackingEnabled = fields.DataTrackEnable?.value;
  const trackingValue = fields.DataTrackValue?.value;
  const trackingDestination = fields.DataTrackDestination?.value;

  const trackingAttributes = {
    'data-track': trackingEnabled ? 'true' : 'false',
    'data-track-value': trackingValue,
    'data-trackt-destination': trackingDestination,
  };

  return trackingAttributes;
};

const getTrackingSecondaryAttributes = (fields) => {
  const trackingEnabled = fields.DataTrackSecondaryEnable?.value;
  const trackingValue = fields.DataTrackSecondaryValue?.value;
  const trackingDestination = fields.DataTrackSecondaryDestination?.value;

  const trackingAttributes = {
    'data-track': trackingEnabled ? 'true' : 'false',
    'data-track-value': trackingValue,
    'data-trackt-destination': trackingDestination,
  };

  return trackingAttributes;
};

const getBackgroundImages = (fields, isLight) => {
  const smallBackgroundImageField = isLight
    ? fields.BackgroundImageSmallLight
    : fields.BackgroundImageSmallDark;
  const mediumBackgroundImageField = isLight
    ? fields.BackgroundImageMediumLight
    : fields.BackgroundImageMediumDark;
  const largeBackgroundImageField = isLight
    ? fields.BackgroundImageLargeLight
    : fields.BackgroundImageLargeDark;

  const smallBackgroundImageSrc =
    smallBackgroundImageField?.value?.class !== 'scEmptyImage'
      ? smallBackgroundImageField?.value?.src
      : '';
  const mediumBackgroundImageSrc =
    mediumBackgroundImageField?.value?.class !== 'scEmptyImage'
      ? mediumBackgroundImageField?.value?.src
      : '';
  const largeBackgroundImageSrc =
    largeBackgroundImageField?.value?.class !== 'scEmptyImage'
      ? largeBackgroundImageField?.value?.src
      : '';

  return {
    smallBackgroundImageField,
    mediumBackgroundImageField,
    largeBackgroundImageField,
    smallBackgroundImageSrc,
    mediumBackgroundImageSrc,
    largeBackgroundImageSrc,
  };
};

const extractPrefixedProperties = (obj, prefix) => {
  return Object.keys(obj).reduce((result, key) => {
    if (key.startsWith(prefix)) {
      // Remove the prefix from the key
      const newKey = key.slice(prefix.length);
      result[newKey] = obj[key];
    }
    return result;
  }, {});
};

const extractSuffixedProperties = (obj, suffix) => {
  return Object.keys(obj).reduce((result, key) => {
    if (key.endsWith(suffix)) {
      // Remove the prefix from the key
      const newKey = key.slice(0, -suffix.length);
      result[newKey] = obj[key];
    }
    return result;
  }, {});
};

const getThemeProperties = (obj, isLight) => {
  if (obj === null || obj === undefined) return {};
  const suffixTheme = extractSuffixedProperties(obj, isLight ? 'Light' : 'Dark');
  const prefixTheme = extractPrefixedProperties(obj, isLight ? 'Light' : 'Dark');
  return { ...prefixTheme, ...suffixTheme };
};

export {
  addStyle,
  getTrackingAttributes,
  getTrackingSecondaryAttributes,
  getBackgroundImages,
  extractPrefixedProperties,
  extractSuffixedProperties,
  getThemeProperties,
};
